import { useEffect, useState } from 'react';
import { bookTryOn, getTryOnAddresses } from '../services/tryOnService';

function TryOnBooking({ product }) {
  const [open, setOpen] = useState(false);
  const [addresses, setAddresses] = useState({ address1: '', address2: '' });
  const [form, setForm] = useState({ name: '', phone: '', date: '', time: '' });
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getTryOnAddresses().then(setAddresses).catch(() => {});
  }, []);

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setMessage('');
    try {
      await bookTryOn({ productId: product.id, ...form });
      setMessage('Request received. ZEVI will contact you on WhatsApp to confirm your session.');
      setForm({ name: '', phone: '', date: '', time: '' });
    } catch (error) {
      setMessage(error.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="zevi-try-on">
      <button type="button" className="outline-button" onClick={() => setOpen(!open)}>
        {open ? 'Close try-on request' : 'Book a try-on'}
      </button>
      {open && (
        <div className="zevi-try-on-panel">
          <h2>Experience it in person</h2>
          <p>Choose a preferred time. Your appointment is confirmed only after ZEVI contacts you on WhatsApp.</p>
          {(addresses.address1 || addresses.address2) && (
            <p>Try-on locations: {[addresses.address1, addresses.address2].filter(Boolean).join(' · ')}</p>
          )}
          <form onSubmit={submit}>
            <label>Name<input required minLength={2} maxLength={100} value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })} /></label>
            <label>Contact number<input required type="tel" minLength={7} maxLength={25} value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })} /></label>
            <label>Preferred date<input required type="date" min={new Date().toLocaleDateString('en-CA')}
              value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} /></label>
            <label>Preferred time<input required type="time" value={form.time}
              onChange={(e) => setForm({ ...form, time: e.target.value })} /></label>
            <button type="submit" className="gold-button" disabled={busy}>
              {busy ? 'Requesting…' : 'Request a session'}
            </button>
          </form>
          {message && <p role="status">{message}</p>}
        </div>
      )}
    </section>
  );
}

export default TryOnBooking;